const tabs = {
  roulette: [],
  nuevo: [],
  popular: [],
  xMas: [],
};

export const gamesOrder = [
  'amigo_3SpiritVolcanoes@AMIGO',
  'amigo_3Tombs@AMIGO',
  'amigo_MoonGirls@AMIGO',
  'amigo_FortuneBags@AMIGO',
  'amigo_5FruitInvaders@AMIGO',
]

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

export { getTab };
